import { render, staticRenderFns } from "./IconWebcam.vue?vue&type=template&id=afe5b430&"
import script from "./IconWebcam.vue?vue&type=script&lang=js&"
export * from "./IconWebcam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports